import { getBnySatGraphBaseUrl } from '../../services/apiService';
import { createApiThunk, graphqlCall } from '../../utils/api';
import { getExceptionQueueQuery } from './ExceptionQueueQueries';
import { print } from 'graphql';

export const getExceptionQueueThunk = createApiThunk('GET_EXCEPTION_QUEUE', graphqlCall);

export const getExceptionQueue = () => (dispatch: AppDispatch) => {
  const url = getBnySatGraphBaseUrl();
  const query = print(getExceptionQueueQuery());
  return dispatch(getExceptionQueueThunk({ url, query }));
};
